import api from '../api';

export async function createStripeCheckoutSession(plan, userId, userEmail, stripeCustomerId) {
    const response = await api.post(
        '/payments/create-checkout-session', 
        { 
            plan, 
            userId, 
            userEmail, 
            stripeCustomerId 
        });
        
    return response.data;
}

export async function createStripePortalSession(userId) {
    const response = await api.post('/payments/create-portal-session', { userId });
    return response.data;
}